<template>
    <div class="container">

        <header class="container__header">

            <h1>Udleveringssteder</h1>

            <router-link class="btn btn--md btn--primary primary--copper margin-t-50" :to="{name:'deliveryPoint.create'}">Tilføj nyt sted</router-link>

        </header>

        <div class="container__body container__body--md">

            <header class="col-12 flex--space padding-b-25 border-b">

                <h1>Oversigt</h1>

            </header>

            <section class="data-list">

                <transition-group name="fade" tag="div">

                    <div class="item" v-for="point in deliveryPoints" :key="point.id">

                        <div class="icon">

                            <i class="icon--lg fas fa-shopping-bag"></i>

                        </div>

                        <div class="content">

                            <h1 v-text="point.name"></h1>

                            <ul>

<!--                                <li v-if="coupon.deleted_at === null">Status: Aktiv</li>
                                <li v-else>Status: Inaktiv</li>
                                <li>Kode: {{coupon.code}}</li>-->
                                <!--<li>Kategori: {{product.category_title}}</li>
                                <li>Pris: {{stripeAmount(product.price).amount}},-</li>-->

                            </ul>

                        </div>

                        <div class="link">

                            <router-link :to="{name:'deliveryPoint.edit', params:{point:point.id}}">Rediger</router-link>

                        </div>

                    </div>

                </transition-group>

            </section>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "delivery-point-index",
        data(){
            return {
                text:'',
            }
        },
        computed:{
            ...mapGetters(['deliveryPoints']),
        },
        created(){
            this.$store.dispatch('getDeliveryPoints');
        }
    }
</script>

<style scoped>

</style>
